import './S_TabsContainer.scss';
import { PropsWithChildren, ReactElement } from 'react';

export const S_TabsContainer = ({ children }: PropsWithChildren): ReactElement => <div className='tabs-container'>{children}</div>;
